module.exports = __webpack_public_path__ + "static/img/subscribe.c2b60c89.svg";